import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { installDeploymentRecovery } from "@evolys/ui";
import { router } from "./router";
import {
  getHubDisciplineConfig,
  hubDiscipline,
} from "./lib/hubMode";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/spotlight/styles.css";
import "@evolys/ui/src/styles/print.css";

installDeploymentRecovery();

if (hubDiscipline) {
  document.title = `EvoLys — ${getHubDisciplineConfig(hubDiscipline).label}`;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
